import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import { SingleDatePicker } from 'react-google-flight-datepicker';
import { Tooltip } from 'antd';
import Image from 'next/image';

const Multiselect = dynamic(() => import('multiselect-react-dropdown').then((module) => module.Multiselect), {
  ssr: false,
});

const selectStyles = {
  multiselectContainer: {
    height: '80px',
    boxSizing: 'border-box',
  },
  searchBox: {
    backgroundColor: 'white',
  },
  inputField: {
    margin: '5px',
  },
  chips: {
    backgroundColor: '#004B8D',
  },
};

const decimalLength = (value) => {
  if (value.indexOf('.') != -1) {
    let temp = value.toString();
    return temp.length - temp.indexOf('.') - 1;
  } else {
    return 0;
  }
};
const convertToBoolean = (value) => {
  return typeof value == 'boolean' ? value : value === 'true' ? true : false;
};
const formatDropDownOption = (value) => {
  let temp = value?.split(/[.\-]/);
  let n = temp?.length;
  let final = '';

  for (let i = 0; i < n - 1; i++) final = final + temp[i] + ' ';

  final = final + temp?.[n - 1];
  return final;
};

const setMultiSelect = (option1) => {
  let arr = [];
  for (let i = 0; i < option1?.length; i++) {
    let obj = {
      value: option1[i],
      label: option1[i],
    };
    arr.push(obj);
  }
  return arr;
};

function todayDate(d = new Date()) {
  d.setDate(new Date().getDate());
  return [d.getFullYear(), d.getMonth() + 1, d.getDate()].map((n) => (n < 10 ? `0${n}` : `${n}`)).join('-');
}

const getValue = (data, datakeys) => {
  let value = JSON.parse(JSON.stringify(data));
  const finalValue = datakeys.filter((key) => key).reduce((tempObj, key) => tempObj && tempObj[key], data);
  // for (let i = 0; i < datakey.length; i++) {
  //   value = value && datakey[i] ? value[datakey[i]] : value;
  // }

  return finalValue;
};
const setValue = (data, datakey, setData, value) => {
  let copyObj = JSON.parse(JSON.stringify(data));
  let i;
  let temp2 = copyObj;
  for (i = 0; i < datakey.length - 1; i++) {
    temp2 = temp2[datakey[i]];
  }
  temp2[datakey[i]] = value;

  setData(copyObj);
};
const inputHandling = (setData, data, dataKey, insideKey, value) => {
  if (Array.isArray(setData)) {
    setData.forEach((func) =>
      func((prev) => ({
        ...prev,
        [dataKey]: insideKey ? { ...prev[dataKey], [insideKey]: value } : value,
      }))
    );
  } else
    setData((prev) => ({
      ...prev,
      [dataKey]: value === '' ? null : value,
    }));
};
const TextInput = ({
  colWidth,
  label,
  hint,
  inputLengthLimit = 99999999,
  data,
  dataKey,
  insideKey = '',
  setData,
  removeSpace,
  padding,
  placeholder,
  disabled,
  trimSpace,
  customStyle,
  removeSpecialCharacters,
  onFocus,
  showToolTip,
  toolTipText,
}) => {
  return (
    <div className={`col-sm-${colWidth} padding-${padding}  ${customStyle}`}>
      <div className='form-group metro-r'>
        {label && (
          <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue capitalize'>
            {label}
            {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
            {showToolTip && 
            <Tooltip
                placement='right'
                color='white'
                overlayClassName='inter fw500 text-black fs11 lh-18'
                overlayInnerStyle={{
                  color: '#000000',
                }}
                title={
                  toolTipText
                }
              >
                <Image src={'/images/info-icon-grey.svg'} height={15} width={25} />
              </Tooltip>
            }
          </label>
        )}
        <input
          onFocus={onFocus}
          type='text'
          className='form-control'
          placeholder={placeholder || label}
          id={label}
          disabled={disabled}
          onBlur={(e) => {
            let value = e.target.value;
            if (trimSpace) {
              value = value.trim();
              inputHandling(setData, data, dataKey, insideKey, value);
            }
          }}
          value={(insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]) || ''}
          onChange={(e) => {
            if (removeSpace) e.target.value = e.target.value.replace(/\s/g, '');
            if (removeSpecialCharacters) e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
            if (e.target.value.length <= inputLengthLimit) {
              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                  }))
                );
              } else
                setData((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                }));
            }
          }}
        />
      </div>
    </div>
  );
};
const TextArea = ({
  colWidth,
  label,
  hint,
  inputLengthLimit = 99999999,
  data,
  dataKey,
  insideKey = '',
  setData,
  rows,
  removeSpace,
  placeholder,
}) => {
  return (
    <div className={`col-sm-${colWidth}`}>
      <div className='form-group metro-r'>
        <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue'>
          {label}
          {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
        </label>
        <textarea
          rows={rows}
          type='text'
          className='form-control'
          placeholder={placeholder || label}
          id={label}
          value={insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]}
          onChange={(e) => {
            if (removeSpace) e.target.value = e.target.value.replace(/\s/g, '');
            if (e.target.value.length <= inputLengthLimit) {
              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                  }))
                );
              } else
                setData((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                }));
            }
          }}
        />
      </div>
    </div>
  );
};

const TextInput2 = ({
  colWidth,
  name,
  label,
  hint,
  inputLengthLimit = 99999999,
  data,
  dataKey,
  insideKey = '',
  setData,
  removeSpace,
  customClasses,
  placeholder,
  disabled,
  trimSpace,
}) => {
  const value = getValue(data, dataKey);
  return (
    <div
      className={` width-${colWidth} ${customClasses.div} ${
        value && 'valid'
      } floating-label-input-div nato-sans pos-rel`}
    >
      <label htmlFor={name} className='bg-white fs14 lh-16'>
        {label}
      </label>
      <input
        disabled={disabled}
        type='text'
        className={`form-inputs width-100 border-1 border-grey bora-2 ${customClasses.input}`}
        id={name}
        value={value || ''}
        onBlur={(e) => {
          let value = e.target.value;
          if (trimSpace) {
            value = value.trim();
            inputHandling(setData, data, dataKey, insideKey, value);
          }
        }}
        onChange={(e) => {
          if (removeSpace) e.target.value = e.target.value.replace(/\s/g, '');
          if (e.target.value.length <= inputLengthLimit) {
            if (Array.isArray(setData)) {
              setData.forEach((func) =>
                func((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                }))
              );
            } else
              setData((prev) => ({
                ...prev,
                [dataKey[0]]: insideKey === '' ? e.target.value : { ...prev[dataKey[0]], [insideKey]: e.target.value },
              }));
          }
        }}
      />
    </div>
  );
};

const NumberInput = ({
  colWidth,
  label,
  data,
  min,
  max,
  hint,
  dataKey,
  insideKey = '',
  setData,
  placeholder,
  disabled,
  decimalPoints,
  trimSpace,
}) => {
  const inputRef = useRef();
  const value = getValue(data, [dataKey, insideKey]);
  const [showToolTip, setShowToolTip] = useState(false);
  useEffect(() => {
    +inputRef.current.value !== value ? (inputRef.current.value = value) : null;
  }, [data[dataKey]]);
  return (
    <div className={`col-sm-${colWidth}`}>
      <div className='form-group metro-r'>
        {label && (
          <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue capitalize'>
            {label}
            {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
          </label>
        )}
        <input
          onWheel={() => inputRef.current.blur()}
          ref={inputRef}
          disabled={disabled}
          type='number'
          className='form-control'
          placeholder={placeholder || label}
          id={label}
          value={value}
          min={min || 0}
          onKeyDown={(evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()}
          onChange={(e) => {
            let value = e.target.value;
            if ((value <= max && value >= min && decimalLength(value) <= (decimalPoints || 3)) || value === '') {
              console.log(value);
              console.log(insideKey);
              value = value === '' ? null : +value;
              inputHandling(setData, data, dataKey, insideKey, value);
            } else value = null;
          }}
        />
      </div>
    </div>
  );
};
const IntegarInput = ({
  colWidth,
  label,
  hint,
  data,
  insideKey = '',
  min,
  max,
  dataKey,
  setData,
  disabled,
  padding,
  onBlur,
  placeholder,
  subtext,
  subtextClasses,
}) => {
  const inputRef = useRef();
  useEffect(() => {
    inputRef.current.value !== data[dataKey] ? (inputRef.current.value = data[dataKey]) : null;
  }, [data]);
  return (
    <div className={`col-sm-${colWidth} padding-${padding} pos-rel`}>
      <div className='form-group metro-r'>
        {label && (
          <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue'>
            <span>{label}</span>
            {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
          </label>
        )}
        <input
          onWheel={() => inputRef.current.blur()}
          ref={inputRef}
          type='number'
          className='form-control'
          placeholder={placeholder || label}
          id={label}
          min={min || 0}
          disabled={disabled}
          value={data[dataKey] === null ? null : data[dataKey]}
          onKeyDown={(evt) => ['e', 'E', '+', '-', '.'].includes(evt.key) && evt.preventDefault()}
          onChange={(e) => {
            let value = e.target.value;
            if ((value <= max && value >= min) || value === '') {
              value = value === '' ? null : +value;
              inputHandling(setData, data, dataKey, insideKey, value);
            } else value = null;
          }}
          onBlur={(e) => onBlur && onBlur(e)}
        />
      </div>
      {subtext && <p className={`${subtextClasses} pos-abs sub-text fs10 lh-12`}>{subtext}</p>}
    </div>
  );
};
const NumberInput2 = ({
  colWidth,
  name,
  label,
  data,
  min,
  max,
  dataKey,
  insideKey = '',
  setData,
  customClasses,
  placeholder,
  disabled,
  decimalPoints,
}) => {
  const inputRef = useRef();
  const value = getValue(data, [dataKey, insideKey]);
  return (
    <div
      className={` width-${colWidth} ${customClasses.div} ${
        (value || value === 0) && 'valid'
      } floating-label-input-div nato-sans pos-rel`}
    >
      <label htmlFor={name} className={`fs14 lh-16 ${disabled ? 'disabled' : 'bg-white'} `}>
        {label}
      </label>
      <input
        ref={inputRef}
        disabled={disabled}
        type='number'
        className={`form-inputs width-100 border-1 border-grey bora-2 ${customClasses.input}`}
        id={name}
        value={value}
        onKeyDown={(evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()}
        onChange={(e) => {
          let value = e.target.value;
          if ((value <= max && value >= min && decimalLength(value) <= (decimalPoints || 3)) || value === '') {
            value = value === '' ? null : +value;
            inputHandling(setData, data, dataKey, insideKey, value);
          } else e.target.value = null;
        }}
      />
    </div>
  );
};

const SwitchInput = ({ colWidth, label, data, dataKey, disabled, insideKey = '', setData }) => {
  // console.log(convertToBoolean(data[dataKey]));
  return (
    <div className={`col-sm-${colWidth}`}>
      <span className='fs14 d-flex margin-t18 justify-content-center lh-16 metro-r text-l-blue'>{label}</span>
      <div className='d-flex justify-content-center margin-t4'>
        <label className='switch'>
          <input
            type='checkbox'
            disabled={disabled}
            checked={convertToBoolean(insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey])}
            onChange={(e) => {
              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]:
                      insideKey === '' ? e.target.checked : { ...prev[dataKey], [insideKey]: e.target.checked },
                  }))
                );
              } else
                setData((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? e.target.checked : { ...prev[dataKey], [insideKey]: e.target.checked },
                }));
            }}
          />
          <span className='slider round'></span>
        </label>
      </div>
    </div>
  );
};

const BooleanInput = ({ colWidth, label, data, dataKey, insideKey = '', setData, placeholder, disabled }) => {
  return (
    <div className={`col-sm-${colWidth}`}>
      <div className='form-group metro-r'>
        <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue capitalize'>
          {label}
        </label>
        <select
          className='form-control arrow-btn'
          id={label}
          disabled={disabled}
          value={insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]}
          onChange={(e) => {
            if (Array.isArray(setData)) {
              setData.forEach((func) =>
                func((prev) => ({
                  ...prev,
                  [dataKey]:
                    insideKey === ''
                      ? convertToBoolean(e.target.value)
                      : { ...prev[dataKey], [insideKey]: convertToBoolean(e.target.value) },
                }))
              );
            } else
              setData((prev) => ({
                ...prev,
                [dataKey]: convertToBoolean(
                  insideKey === ''
                    ? convertToBoolean(e.target.value)
                    : { ...prev[dataKey], [insideKey]: convertToBoolean(e.target.value) }
                ),
              }));
          }}
        >
          <option className='placeholder' value='' selected disabled hidden>
            {placeholder || 'Select Type'}
          </option>
          <option className='placeholder' value={true}>
            True
          </option>
          <option className='placeholder' value={false}>
            False
          </option>
        </select>
      </div>
    </div>
  );
};

const DropDownInput = ({
  colWidth,
  label,
  data,
  dataKey,
  insideKey = '',
  setData,
  options,
  placeholder,
  padding,
  customFormat,
  disabled,
  customClasses,
  trimSpace,
  optionValues,
}) => {
  return (
    <div className={`col-sm-${colWidth} padding-${padding}`}>
      <div className={`form-group metro-r ${customClasses?.inputWapper} `}>
        {label && (
          <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue'>
            {label}
          </label>
        )}
        <select
          className='form-control arrow-btn'
          id={label}
          disabled={disabled}
          value={insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]}
          onChange={(e) => {
            if (Array.isArray(setData)) {
              setData.forEach((func) =>
                func((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                }))
              );
            } else
              setData((prev) => ({
                ...prev,
                [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
              }));
          }}
        >
          <option className='placeholder' value='' selected disabled hidden>
            {placeholder || label}
          </option>
          {options.map((each, i) => {
            return (
              <option value={optionValues?.[i] ?? each} key={each} style={{ textTransform: 'capitalize' }}>
                {customFormat ? customFormat(each) : formatDropDownOption(each)}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

const DropDownInput2 = ({
  colWidth,
  label,
  data,
  dataKey,
  insideKey = '',
  setData,
  options,
  customClasses,
  optionValues,
  disabled,
  isBoolean,
}) => {
  return (
    <div className={` width-${colWidth} ${customClasses.div} valid floating-label-input-div nato-sans pos-rel`}>
      <label htmlFor={name} className={` fs14 lh-16 ${disabled ? 'disabled' : 'bg-white'}`}>
        {label}
      </label>
      <select
        className={`form-inputs width-100 border-1 border-grey bora-2 ${customClasses.input} arrow-blue`}
        id={label}
        disabled={disabled}
        value={insideKey === '' ? data[dataKey] : data[dataKey][insideKey]}
        onChange={(e) => {
          let value = e.target.value;
          if (isBoolean) value = convertToBoolean(value);
          setData((prev) => ({
            ...prev,
            [dataKey]: insideKey === '' ? value : { ...prev[dataKey], [insideKey]: value },
          }));
        }}
      >
        {options.map((each, i) => {
          return (
            <option value={optionValues?.[i] ?? each} key={each} style={{ textTransform: 'capitalize' }}>
              {formatDropDownOption(each)}
            </option>
          );
        })}
      </select>
    </div>
  );
};

const MultiSelectInput = ({
  colWidth,
  padding,
  label,
  hint,
  data,
  dataKey,
  insideKey = '',
  setData,
  options,
  selectedValueDecorator,
  optionValueDecorator,
  disabled,
}) => {
  return (
    <div className={`col-sm-${colWidth} padding-${padding}`}>
      <div className='form-group metro-r'>
        <label className='fs14 lh-16 metro-r text-l-blue'>
          {label}
          {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
        </label>

        <div>
          <Multiselect
            // isMulti
            name='multi'
            id='css_custom'
            placeholder={`Select Options`}
            options={setMultiSelect(options)}
            disable={disabled}
            style={selectStyles}
            showArrow={true}
            selectedValueDecorator={selectedValueDecorator}
            optionValueDecorator={optionValueDecorator}
            selectedValues={setMultiSelect(
              insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]
            )}
            displayValue='value'
            onRemove={(e) => {
              let temp = JSON.parse(JSON.stringify(data));
              let arr = [];
              for (let i = 0; i < e.length; i++) arr.push(e[i].value);
              temp = arr;
              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? arr : { ...prev[dataKey], [insideKey]: arr },
                  }))
                );
              } else
                setData({
                  ...data,
                  [dataKey]: insideKey === '' ? arr : { ...data[dataKey], [insideKey]: arr },
                });
            }}
            onSelect={(e) => {
              let temp = JSON.parse(JSON.stringify(data));
              let arr = [];
              for (let i = 0; i < e.length; i++) arr.push(e[i].value);
              temp = arr;
              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? arr : { ...prev[dataKey], [insideKey]: arr },
                  }))
                );
              } else
                setData({
                  ...data,
                  [dataKey]: insideKey === '' ? arr : { ...data[dataKey], [insideKey]: arr },
                });
            }}
          />
        </div>
      </div>
    </div>
  );
};

const DateInput = ({
  colWidth,
  label,
  data,
  dataKey,
  insideKey = '',
  setData,
  startDate,
  maxDate,
  minDate,
  disabled,
  returnLocal,
}) => {
  return (
    <div className={`col-sm-${colWidth}`}>
      <div className='form-group metro-r'>
        <label className='fs14 lh-16 metro-r text-l-blue'>{label}</label>
        <div>
          <SingleDatePicker
            highlightToday
            className='date-picker'
            disabled={disabled}
            startDatePlaceholder={`Select ${label}`}
            startDate={data[dataKey]}
            onChange={(e) => {
              let temp = JSON.parse(JSON.stringify(data));
              let val = '';

              if (e != null) val = returnLocal ? e : e.toISOString();
              temp[dataKey] = val;

              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? val : { ...prev[dataKey], [insideKey]: val },
                  }))
                );
              } else
                setData((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? val : { ...prev[dataKey], [insideKey]: val },
                }));
            }}
            singleCalendar='true'
            minDate={minDate}
            {...(maxDate !== 'none' && { maxDate: maxDate || todayDate() })}
          />
        </div>
      </div>
    </div>
  );
};
const RangeInput = ({
  colWidth,
  label,
  hint,
  data,
  insideKey = '',
  min,
  max,
  dataKey,
  setData,
  disabled,
  padding,
  onBlur,
  placeholder,
  subtext,
  subtextClasses,
}) => {
  return (
    <div className={`col-sm-${colWidth} padding-${padding} pos-rel`}>
      <div className='form-group metro-r'>
        <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue'>
          <span>{label}</span>
          {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
          <span className='fw700 text-black margin-l10'>{data[dataKey] === null ? null : data[dataKey]}</span>
        </label>
        <input
          type='range'
          className='form-control padding-0'
          placeholder={placeholder || label}
          id={label}
          min={min || 0}
          max={max}
          disabled={disabled}
          value={data[dataKey] === null ? null : data[dataKey]}
          onChange={(e) => {
            const value = e.target.value;
            if (Array.isArray(setData)) {
              setData.forEach((func) =>
                func((prev) => ({
                  ...prev,
                  [dataKey]: insideKey ? { ...prev[dataKey], [insideKey]: value } : value,
                }))
              );
            } else
              setData((prev) => ({
                ...prev,
                [dataKey]: insideKey ? { ...prev[dataKey], [insideKey]: value } : value,
              }));
          }}
          onBlur={(e) => onBlur && onBlur(e)}
        />
      </div>
      {subtext && <p className={`${subtextClasses} pos-abs sub-text fs10 lh-12`}>{subtext}</p>}
    </div>
  );
};

const ColorPicker = ({
  colWidth,
  label,
  hint,
  inputLengthLimit = 99999999,
  data,
  dataKey,
  insideKey = '',
  setData,
  padding,
  placeholder,
  disabled,
  customStyle,
  removeSpace,
  trimSpace,
}) => {
  const currentRef = useRef(null);

  return (
    <div className={` padding-${padding} color-picker-style  ${customStyle} `}>
      <div className='form-group metro-r color-picker-input'>
        {label && (
          <label htmlFor={label} className='fs14 lh-16 metro-r text-l-blue capitalize'>
            {label}
            {hint && <span className='fs10 text-l-blue'> ( {hint} )</span>}
          </label>
        )}
        <input
          type='text'
          className={`col-sm-6 border-0 margin-t15 noto-sans fs14 fw500`}
          id={label}
          disabled={disabled}
          onBlur={(e) => {
            let value = e.target.value;
            if (trimSpace) {
              value = value.trim();
              inputHandling(setData, data, dataKey, insideKey, value);
            }
          }}
          value={(insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]) || ''}
          onChange={(e) => {
            if (removeSpace) e.target.value = e.target.value.replace(/\s/g, '');
            if (e.target.value.length <= inputLengthLimit) {
              if (Array.isArray(setData)) {
                setData.forEach((func) =>
                  func((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                  }))
                );
              } else
                setData((prev) => ({
                  ...prev,
                  [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                }));
            }
          }}
        />
        <div onClick={() => currentRef.current.click()} className='colorpicker cursor-pointer'>
          <input
            ref={currentRef}
            type='color'
            placeholder={placeholder || label}
            id={label}
            disabled={disabled}
            onBlur={(e) => {
              let value = e.target.value;
              if (trimSpace) {
                value = value.trim();
                inputHandling(setData, data, dataKey, insideKey, value);
              }
            }}
            value={(insideKey === '' ? data[dataKey] : data[dataKey] && data[dataKey][insideKey]) || ''}
            onChange={(e) => {
              if (removeSpace) e.target.value = e.target.value.replace(/\s/g, '');
              if (e.target.value.length <= inputLengthLimit) {
                if (Array.isArray(setData)) {
                  setData.forEach((func) =>
                    func((prev) => ({
                      ...prev,
                      [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                    }))
                  );
                } else
                  setData((prev) => ({
                    ...prev,
                    [dataKey]: insideKey === '' ? e.target.value : { ...prev[dataKey], [insideKey]: e.target.value },
                  }));
              }
            }}
          />

          <svg
            onClick={() => currentRef.current.click()}
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M16 3.64093C15.9994 2.67542 15.6155 1.74948 14.9329 1.06672C14.2502 0.383958 13.3244 0.000333988 12.3588 6.0906e-07C11.3934 -0.000557515 10.4672 0.382491 9.78405 1.06453L8.58129 2.26746L7.46672 1.1553L5.95744 2.6648L7.06944 3.77695L1.69087 9.15626C1.45686 9.39067 1.28071 9.67662 1.17615 9.991L0.109583 13.1914C-0.0583834 13.6952 -0.0325307 14.2434 0.182126 14.7292C0.396969 15.2149 0.784983 15.603 1.27065 15.8178C1.75632 16.0325 2.30451 16.0584 2.80822 15.8904L6.00817 14.8237C6.32253 14.7191 6.60841 14.543 6.84279 14.3089L12.2214 8.92958L13.3334 10.0417L14.8426 8.53224L13.7306 7.42009L14.9334 6.21459C15.6181 5.5335 16.002 4.60684 16 3.64095L16 3.64093ZM5.33334 12.7993L2.13339 13.8661L3.19996 10.6657L8.57853 5.28635L10.7119 7.42002L5.33334 12.7993ZM13.4238 4.70727L12.2211 5.9102L10.0877 3.77652L11.2904 2.57359L11.2906 2.57378C11.57 2.275 11.9586 2.10236 12.3676 2.09567C12.7767 2.08878 13.1708 2.24822 13.46 2.5375C13.7493 2.82679 13.9087 3.22103 13.9018 3.63008C13.8951 4.03918 13.7225 4.42781 13.4238 4.70723L13.4238 4.70727Z'
              fill='#004B8D'
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export { TextInput };
export { TextArea };
export { TextInput2 };
export { NumberInput };
export { NumberInput2 };
export { IntegarInput };
export { SwitchInput };
export { DropDownInput };
export { DropDownInput2 };
export { BooleanInput };
export { MultiSelectInput };
export { DateInput };
export { RangeInput };
export { ColorPicker };
